export default {"src":"/_next/static/media/faq_question.bc5baff9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};